<div class="standard-categories-admin-login">
  <div class="login-card">
    <dx-text-box
      [(value)]="password"
      mode="password"
      [width]="300"
      [placeholder]="'COMMON.FIELDS.PASSWORD' | translate"
      [isValid]="!loginError"
      [validationError]="loginError
        ? { message: ('ADMINISTRATION.INVALID-PASSWORD' | translate) }
        : null"
      (onEnterKey)="login()"
    ></dx-text-box>

    <dx-button
      type="normal"
      [width]="130"
      [text]="'COMMON.ENTER' | translate"
      [disabled]="!password"
      (onClick)="login()"
    ></dx-button>
  </div>
</div>